import { render, staticRenderFns } from "./ManageTreatmentList.vue?vue&type=template&id=10128a49&scoped=true&"
import script from "./ManageTreatmentList.vue?vue&type=script&lang=js&"
export * from "./ManageTreatmentList.vue?vue&type=script&lang=js&"
import style0 from "./ManageTreatmentList.vue?vue&type=style&index=0&id=10128a49&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10128a49",
  null
  
)

export default component.exports